import { getRbacAccessToken } from "./memberManagementService";

/**
 * Return the token to send as ``Authorization: Bearer <token>`` on API calls.
 *
 * Under unified-auth this is the RBAC user JWT minted at login (scoped to the
 * active facility), not the retired ``risa_front_end_user`` credential. Kept as
 * ``getBearerToken`` so the many existing call sites continue to work unchanged.
 *
 * @returns The RBAC access token, or ``null`` before login / when unavailable.
 */
export async function getBearerToken(): Promise<string | null> {
  return getRbacAccessToken();
}

/**
 * Backwards-compatible no-op. The RBAC token lifecycle is owned by the member
 * management token manager and cleared on logout via
 * ``clearMemberManagementToken``; there is no separate bearer cache to clear.
 */
export function clearBearerToken(): void {
  // Intentionally empty — retained for API compatibility with call sites that
  // still invoke it during logout flows.
}
